import React from 'react';

const MyTIDeepResearch = () => {
  return <div>DeepResearch</div>;
};

export default MyTIDeepResearch;
